import { ProgressiveImageProps } from 'layout/image-container/progressive-image/progressive-image.props';

export const ProgressiveImagePresets: ProgressiveImageProps = {
  alt: '',
  height: '100%',
  imageData: null,
  objectFit: 'cover',
  visible: false,
};
